import axios from "axios";

const domainURL = "https://ly-iphone-store-backend.onrender.com/api";
// const domainURL = "http://localhost:5002/api";

export const OfferServiceService = {
  // [ADMIN]
  getOfferServices: async (params) => {
    try {
      if (Array.isArray(params.offerServiceIds)) {
        params = {
          ...params,
          offerServiceIds: params.offerServiceIds.join(","),
        };
      }

      const response = await axios.get(`${domainURL}/offer-services/`, {
        params,
      });
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching offerServices:", error);
      return { Data: null, Error: error };
    }
  },

  // [ADMIN]
  getAllOfferServices: async (params) => {
    try {
      const response = await axios.get(
        `${domainURL}/offer-services/all-offerServices`,
        params
      );
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching offerServices:", error);
      return { Data: null, Error: error };
    }
  },

  getListOfferServices: async (params) => {
    try {
      if (Array.isArray(params.offerServiceIds)) {
        params = {
          ...params,
          offerServiceIds: params.offerServiceIds.join(","),
        };
      }

      const response = await axios.get(`${domainURL}/offer-services/get-list`, {
        params,
      });
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching offerServices:", error);
      return { Data: null, Error: error };
    }
  },

  getOfferServiceDetail: async (offerServiceSlug) => {
    try {
      const response = await axios.get(
        `${domainURL}/offer-services/${offerServiceSlug}`
      );
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching offerServices:", error);
      return { Data: null, Error: error };
    }
  },
  uploadOfferServiceImages: async (formData) => {
    try {
      const response = await axios.post(
        `${domainURL}/offer-services/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching offerServices:", error);
      return { Data: null, Error: error };
    }
  },
  addOfferService: async (offerServiceData) => {
    try {
      const response = await axios.post(
        `${domainURL}/offer-services/`,
        offerServiceData
      );
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching offerServices:", error);
      return { Data: null, Error: error };
    }
  },
  updateOfferService: async (id, updatedOfferService) => {
    try {
      const response = await axios.put(
        `${domainURL}/offer-services/${id}`,
        updatedOfferService
      );
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching offerServices:", error);
      return { Data: null, Error: error };
    }
  },

  // [DELETE]
  deleteOfferService: async (id) => {
    try {
      const response = await axios.delete(`${domainURL}/offer-services/${id}`);
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching offerServices:", error);
      return { Data: null, Error: error };
    }
  },
  deleteSelectedOfferServices: async (ids) => {
    try {
      const response = await axios.delete(`${domainURL}/offerServices`, {
        data: { ids }, // Truyền danh sách ID vào body request
      });
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error deleting offerServices:", error);
      return { Data: null, Error: error };
    }
  },

  // [IMPORT]
  importOfferServices: async (formData) => {
    try {
      const response = await axios.post(
        `${domainURL}/offer-services/import`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching offerServices:", error);
      return { Data: null, Error: error };
    }
  },
};
